import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const links = [
    { id: 1, link: "/inicio", label: "Inicio" },
    { id: 2, link: "/contacto", label: "Contacto" },
    { id: 3, link: "/politica-de-privacidad", label: "Política de Privacidad" }, // Añadido aquí
  ];

  return (
    <div className={styles.footer}>
      <div className={styles.footerLogo}>
        <p>A buen hacer, buen parecer.</p>
      </div>
      <div className={styles.footerLinks}>
        {links.map((item) => (
          <Link key={item.id} to={item.link} className={styles.footerLink}>
            {item.label}
          </Link>
        ))}
      </div>
      <div className={styles.footerCopyright}>
        &copy; {new Date().getFullYear()} BonFer Tech. Todos los derechos reservados.
      </div>
    </div>
  );
};

export default Footer;
